import React from "react";
import * as Slider from "@radix-ui/react-slider";
import styled from "styled-components";

// Single-thumb slider over Radix primitives. Radix's value/onValueChange are
// array-shaped (multi-thumb support); this wrapper hides that for the common
// single-value case so call sites read like the native input did.
function ToolSlider({ min, max, step = 1, value, onValueChange, ariaLabel }) {
  return (
    <Root
      min={min}
      max={max}
      step={step}
      value={[value]}
      onValueChange={(arr) => onValueChange(arr[0])}
      aria-label={ariaLabel}
    >
      <Track>
        <Range />
      </Track>
      <Thumb />
    </Root>
  );
}

const Root = styled(Slider.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
  height: 20px;
`;

const Track = styled(Slider.Track)`
  position: relative;
  flex-grow: 1;
  background: var(--color-chrome);
  border-radius: 999px;
  height: 4px;
`;

const Range = styled(Slider.Range)`
  position: absolute;
  background: var(--color-chrome-active);
  border-radius: 999px;
  height: 100%;
`;

const Thumb = styled(Slider.Thumb)`
  display: block;
  width: 16px;
  height: 16px;
  background: var(--color-surface);
  border: 1.5px solid var(--color-chrome-active);
  border-radius: 50%;
  cursor: grab;

  &:hover {
    background: var(--color-chrome-hover);
  }

  /* Inverted fill on focus: hollow thumb (surface bg + active border)
     becomes filled (active bg + text border). Avoids stacking another
     active-color ring on top of the active-color border + range, which
     read as visual noise rather than a focus state. */
  &:focus-visible {
    background: var(--color-chrome-active);
    border-color: var(--color-text);
    outline: none;
  }

  &[data-state="active"] {
    cursor: grabbing;
  }
`;

export default ToolSlider;
